import { MutationTree } from "vuex";
import { ShowSnackbar, SET_SHOWSNACKBAR } from "./types";

export const mutations: MutationTree<ShowSnackbar> = {
  [SET_SHOWSNACKBAR](state, showSnackbar: boolean) {
    state.showSnackbar = showSnackbar;
  }
};
